var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('el-button',{attrs:{"type":"primary","size":"mini","icon":"el-icon-plus"}},[_vm._v(_vm._s(_vm.sLabel))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }